"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.array.map.js");

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _GeneralTab = _interopRequireDefault(require("../../tabs/general/GeneralTab/GeneralTab"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["layer", "onFinish", "onFinishFailed", "tabs"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var layout = {
  labelAlign: 'left',
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};
var tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 3
  }
};
/**
 * A basic Form for the ol/layer/Base Layer.
 */

var EditLayerForm = function EditLayerForm(_ref) {
  var layer = _ref.layer,
      onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? [{
    title: "General",
    key: "general",
    isDefault: true,
    el: _GeneralTab.default
  }] : _ref$tabs,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0]; //get first key as the default active key for the tab


  var defaultActiveKey = tabs[0].key; //get options

  var opts = {};
  tabs.forEach(function (tab) {
    opts = _objectSpread(_objectSpread({}, opts), tab.el.getOpts(layer));

    if (tab.isDefault === true) {
      defaultActiveKey = tab.key;
    }
  });

  var onReset = function onReset() {
    form.resetFields();
  };

  var onFill = function onFill() {
    form.setFieldsValue(opts);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Form, _objectSpread(_objectSpread({}, layout), {}, {
    //layout="vertical"
    form: form,
    name: "edit-layer-form",
    onFinish: onFinish,
    initialValues: opts,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs, {
      defaultActiveKey: defaultActiveKey,
      children: tabs.map(function (Tab) {
        var TabItem = Tab.el;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Tabs.TabPane, {
          tab: Tab.title,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TabItem, {
            mode: "edit"
          })
        }, Tab.key);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, _objectSpread(_objectSpread({}, tailLayout), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_antd.Space, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          type: "primary",
          htmlType: "submit",
          children: "Submit"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          htmlType: "button",
          onClick: onReset,
          children: "Reset"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
          type: "link",
          htmlType: "button",
          onClick: onFill,
          children: "Fill form"
        })]
      })
    }))]
  }));
};

var _default = EditLayerForm;
exports.default = _default;